import React from 'react';
import { cn } from '../../utils/lib/utils';
/**
 * @typedef {Object} DatePickerProps
 * @property {*} selected | null;
 * @property {*} onChange
 * @property {*} minDate?;
 * @property {*} maxDate?;
 * @property {*} placeholderText?;
 * @property {*} disabled?;
 */
export const DatePicker = React.forwardRef(({ 
  selected, 
  onChange, 
  minDate, 
  maxDate, 
  placeholderText, 
  disabled,
  className,
  ...props 
}, ref) => {
  return (
    <input
      ref={ref}
      type="date"
      value={selected}
      onChange={onChange}
      min={minDate}
      max={maxDate}
      placeholder={placeholderText}
      disabled={disabled}
      className={cn(
        "w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
      {...props}
    />
  );
});

DatePicker.displayName = 'DatePicker';
